// extracted by mini-css-extract-plugin
export var cancelButton = "_nn-5";
export var content = "_nn-3";
export var createButton = "_nn-6";
export var drawerContainer = "_nn-0";
export var footer = "_nn-2";
export var header = "_nn-1";
export var orderFormColumn = "_nn-4";